import { getOptjobAsObject, OptJobStatusObject, OptJobType, useLatestOptJobStatus } from 'api/optJobs/optJobs.api'
import { useMemo } from 'react'

export function usePreviousRegularOptJobTime(
  regularOptJobType: Extract<OptJobType, 'regular' | 'regular_wip'>,
  comparePlansFeatureFlag: boolean
) {
  const { data: latestFinishedRegularOptJobData } = useLatestOptJobStatus({
    type: regularOptJobType,
    enabled: comparePlansFeatureFlag,
    limit: 2,
  })

  return useMemo(() => {
    if (!comparePlansFeatureFlag || !latestFinishedRegularOptJobData?.length) {
      return ''
    }

    const secondToFirstFinishedOptJob: OptJobStatusObject | null | undefined = getOptjobAsObject(
      latestFinishedRegularOptJobData,
      1
    )

    if (secondToFirstFinishedOptJob?.created_at) {
      return secondToFirstFinishedOptJob.created_at
    }

    return ''
  }, [comparePlansFeatureFlag, latestFinishedRegularOptJobData])
}
